import { render } from "./CompanyRules.vue?vue&type=template&id=a9108ac6"
import script from "./CompanyRules.vue?vue&type=script&lang=js"
export * from "./CompanyRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__